module.exports = __webpack_public_path__ + "img/6.93ba0c26.jpg";